import { useMutation } from 'react-query';

import { getAPIErrorMessage } from '@nw/shared/utils';

import {
  CancelInstallmentRequestSchema,
  CancelInstallmentRequestType,
  SuccessResponseSchema,
  SuccessResponseType
} from '../../../services/IbInstallmentsServices/APIService/types';

import { useIbInstallmentsService } from '../useIbInstallmentsService';

interface UseCancelInstallmentApiInterface {
  cancelInstallmentApi: (
    input: CancelInstallmentRequestType
  ) => Promise<SuccessResponseType>;
  isLoading: boolean;
  isError: boolean;
  error: string | null;
  status: 'idle' | 'loading' | 'success' | 'error';
  reset: () => void;
}

const useCancelInstallmentApi = (): UseCancelInstallmentApiInterface => {
  const { ibInstallmentsServiceInstance } = useIbInstallmentsService();

  const cancelInstallment = (requestObject: CancelInstallmentRequestType) => {
    try {
      // Always validate request object against schema
      CancelInstallmentRequestSchema.parse(requestObject);
    } catch (error) {
      console.error('Invalid request object:', error);
      throw error;
    }

    return ibInstallmentsServiceInstance
      .cancelInstallment(requestObject)
      .then((response) => {
        return response;
      });
  };

  const { mutateAsync, isLoading, isError, error, status, reset } = useMutation(
    cancelInstallment,
    {
      mutationKey: ['cancelInstallmentApi']
    }
  );

  return {
    cancelInstallmentApi: mutateAsync,
    isLoading,
    isError,
    error: error ? getAPIErrorMessage(error) : null,
    status,
    reset
  };
};

export { useCancelInstallmentApi };
